export default __webpack_public_path__ + "static/media/851.d12ba335.png";